import React, {Component} from 'react'
import LayoutDashboard from "../../components/layout-dashboard";
import {connect} from "react-redux";
import {createResource, deleteResource, getResource, updateResource} from "../../data/actions/resource";
import LocalStorage from "../../util/localStorage";
import {Field, FieldsManager} from "../../data/services/fields";
import Resources from "../../data/services/resources";
import {
    checkPerm,
    CREATE_PERM, DEFAULT_CRUD_STATE, DELETE_PERM,
    fillFieldsFromData,
    getHomePage,
    getProp,
    READ_PERM, UPDATE_PERM,
    userBelongsToType
} from "../../util/util";
import FieldSearch from "../../components/field-search";
import {PlusIcon} from "@heroicons/react/solid";
import SimpleTable from "../../components/simple-table";
import ModalSaveResource from "../../components/modal/modal-save-resource";
import ModalConfirm from "../../components/modal/modal-confirm";
import PageHeader from "../../components/layout-dashboard/page-header";
import ModalViewResource from "../../components/modal/modal-view-resource";
import ArchivedSwitch from "../../components/archived-switch";

class ClientsPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ...DEFAULT_CRUD_STATE,
            sortBy: "FirstName",

            fields: this.getFields(),

            archived: false,

            selectedItem: null,
            createModalOpen: false,
            editModalOpen: false,
            viewModalOpen: false,
            confirmModalOpen: false,
            LocationID: 0,
            remountFields: 0
        };
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        if (userBelongsToType(this.props.user.data, ["Client"])) {
            this.props.history.push(getHomePage(this.props.user.data));
        } else {
            this.fetchData();
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.props.resource.isLoading && !!prevProps.resource.isLoading) {
            this.setState({
                LocationID: getProp(this.props, "resource.data.LocationID", 0),
                remountFields: this.state.remountFields + 1
            })
        }
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getResource({
            user: LocalStorage.get("user"),
            query: this.getQuery(),
            resource: this.getResourceName()
        }))
    };

    handleRestore = (it) => {
        this.props.dispatch(updateResource({
            user: LocalStorage.get("user"),
            query: this.getQuery(),
            params: {
                ArchivedDate: 1,
                [this.getPrimaryKey()]: it[this.getPrimaryKey()]
            },
            resource: Resources.Client,
            piggyResource: Resources.Clients
        }));
    }

    /** UI Events
     ================================================================= */
    handleUpdateSort = (sortBy) => {
        this.setState({
            sortBy: sortBy,
            sort: (this.state.sortBy === sortBy) ? (this.state.sort === "ASC" ? "DESC" : "ASC") : "ASC"
        }, () => this.fetchData())
    };

    handleUpdateOffset = (offset, page) => {
        this.setState({
            offset: offset,
            paginationPage: page
        }, () => this.fetchData());
    }

    handleToggleCreateModal = () => {
        this.setState({
            createModalOpen: !this.state.createModalOpen
        })
    }

    handleToggleConfirmModal = (item = null) => {
        this.setState({
            selectedItem: item,
            confirmModalOpen: !this.state.confirmModalOpen
        })
    }

    handleQueryChange = (name, value) => {
        this.setState({
            query: value
        }, this.fetchData)
    }

    handleToggleViewModal = (item) => {
        this.setState({
            selectedItem: item,
            viewModalOpen: !this.state.viewModalOpen
        });
    }

    handleClientClick = item => {
        this.props.history.push(Resources.Client + "/" + item.ClientID);
    }

    handleInputChange = (fields, name, value) => {
        if ("LocationID" === name) {
            const LocationID = this.state.LocationID ;
            fields = FieldsManager.updateField(fields, "PrimaryPhysicianID", null);
            fields.PrimaryPhysicianID.disabled = false;
            if (value != LocationID) {
                this.setState({
                    LocationID: value?.value,
                    remountFields: this.state.remountFields + 1
                })
            }
        }

        return FieldsManager.updateField(fields, name, value);
    }

    /** Helpers
     ================================================================= */
    getPrimaryKey = () => {
        return "ClientID";
    }

    getResourceName = () => {
        return Resources.Clients;
    }

    getQuery = () => {
        return {
            limit: this.state.limit,
            offset: this.state.offset,
            sort: this.state.sort,
            sortBy: this.state.sortBy,
            query: this.state.query,
            archived: this.state.archived ? 1 : 0
        }
    }

    getFields = (item = null, excludeFields = null, includeFields = null) => {
        const fieldTemplates = {
            LocationID: new Field("LocationID", '', ['empty'], false, "select-search"),
            PrimaryPhysicianID: new Field("PrimaryPhysicianID", '', ['empty'], true, "select-search"),
            FirstName: new Field("FirstName", '', ['empty'], false, "text"),
            LastName: new Field("LastName", '', ['empty'], false, "text"),
            Email: new Field("Email", '', ['empty'], false, "text"),
            Phone: new Field("Phone", '', [''], false, "text"),

            Registered: new Field("Registered", '', [''], false, "checkbox"),

            Birthdate: new Field("Birthdate", '', [''], false, "date"),
            GenderID: new Field("GenderID", '', [''], false, "select"),
            Address1: new Field("Address1", '', [''], false, "text"),
            Address2: new Field("Address2", '', [''], false, "text"),
            City: new Field("City", '', [''], false, "text"),
            StateID: new Field("StateID", '', [''], false, "text"),
            Zip: new Field("Zip", '', [''], false, "text"),

            MembershipLevelID: new Field("MembershipLevelID", '', [''], false, "select"),
            Notes: new Field("Notes", '', [''], false, "textarea"),
        };

        if (excludeFields) {
            excludeFields.forEach((item) => {
                delete fieldTemplates[item];
            });
        }

        if (includeFields) {
            for (const [key] of Object.entries(fieldTemplates)) {
                if (!includeFields.includes(key)) {
                    delete fieldTemplates[key];
                }
            }
        }

        return fillFieldsFromData(fieldTemplates, item);
    };

    getReadOnlyFields = (item = null) => {
        const fieldTemplates = {
            FirstName: new Field("FirstName", '', ['empty'], false, "readonly", {formGroupClass: "sm:col-span-1"}),
            LastName: new Field("LastName", '', ['empty'], false, "readonly", {formGroupClass: "sm:col-span-1"}),
            Email: new Field("Email", '', [''], false, "readonly", {formGroupClass: "col-span-1"}),
            Phone: new Field("Phone", '', [''], false, "readonly", {formGroupClass: "col-span-1"}),
            PrimaryPhysician: new Field("PrimaryPhysician", '', [''], false, "readonly", {formGroupClass: "col-span-1"}),
            LocationName: new Field("LocationName", '', [''], false, "readonly", {formGroupClass: "col-span-1"}),
        };

        return fillFieldsFromData(fieldTemplates, item);
    }

    /** Render
     ================================================================= */
    render() {
        const {translate} = this.props;

        const data = getProp(this.props, "resource.data.list", []);
        const count = getProp(this.props, "resource.data.count", 0);

        const isLoading = getProp(this.props, "resource.isLoading", false);

        const metadata = {
            LocationID: {
                api: 'api/' + Resources.Locations,
                query: {},
                searchMap: (item) => ({
                    value: item.LocationID,
                    label: item.LocationName
                })
            },
            PrimaryPhysicianID: {
                api: 'api/' + Resources.Physicians,
                query: {LocationID: this.state.LocationID},
                searchMap: (item) => ({
                    value: item.PhysicianID,
                    label: item.FirstName + " " + item.LastName
                })
            },
        };

        const tableFields = ["FirstName", "LastName", "PrimaryPhysicianID", "Registered"];

        return (
            <LayoutDashboard {...this.props}>
                <main className="flex-1 relative pb-8 z-0 overflow-y-auto min-h-[calc(100vh-8.75rem)]">
                    <PageHeader
                        title={translate("page.title.clients")}
                    />

                    {/* Page content */}
                    <div className="p-4 sm:p-6 lg:p-8">
                        <div className="flex flex-wrap">
                            <FieldSearch
                                onChange={this.handleQueryChange}
                                name={"query"}
                                value={this.state.query}
                                placeholder="Search"
                                classNameContainer={"mr-6 mb-3"}
                            />

                            <div className="ml-auto flex space-x-8">
                                {checkPerm(Resources.Clients, CREATE_PERM) && (
                                    <ArchivedSwitch
                                        classNameContainer="h-9 md:ml-auto mb-2"
                                        translate={translate}
                                        value={this.state.archived}
                                        onChange={(val) => this.setState({archived: val, paginationPage: 1, offset: 0}, this.fetchData)}
                                    />
                                )}

                                {checkPerm(Resources.Clients, CREATE_PERM) && (
                                    <div className="ml-auto mb-3">
                                        <button
                                            type="button"
                                            onClick={this.handleToggleCreateModal}
                                            className="btn btn-primary focus:ring-offset-inverse"
                                        >
                                            <PlusIcon className="-ml-1 mr-1 h-5 w-5" aria-hidden="true"/>
                                            {translate("btn.add")}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <SimpleTable
                            data={data}
                            count={count}

                            fields={this.getFields(null, null, tableFields)}
                            translate={this.props.translate}
                            isLoading={isLoading}

                            limit={this.state.limit}
                            offset={this.state.offset}
                            paginationPage={this.state.paginationPage}
                            onOffsetChange={this.handleUpdateOffset}

                            sort={this.state.sort}
                            sortBy={this.state.sortBy}
                            onSortChange={this.handleUpdateSort}

                            onView={checkPerm(Resources.Clients, READ_PERM) && this.handleToggleViewModal}
                            onEdit={checkPerm(Resources.Clients, UPDATE_PERM) && this.handleClientClick}
                            onDelete={checkPerm(Resources.Clients, DELETE_PERM) && this.handleToggleConfirmModal}
                            onRestore={this.handleRestore}
                        />
                    </div>

                    <ModalSaveResource
                        bodyKey={this.state.remountFields}
                        title={"Add Client"}
                        addClass="max-w-xl"
                        visible={this.state.createModalOpen}
                        onClose={this.handleToggleCreateModal}
                        handleInputChange={this.handleInputChange}
                        fields={this.getFields(null, ["Birthdate", "GenderID", "Address1", "Address2", "City", "StateID", "Zip", "Registered"])}
                        onSubmit={(params) => {
                            if (params) {
                                this.props.dispatch(createResource({
                                    user: LocalStorage.get("user"),
                                    query: this.getQuery(),
                                    params: params,
                                    resource: Resources.Client,
                                    piggyResource: this.getResourceName()
                                }));
                                this.handleToggleCreateModal(false)
                            }
                        }}
                        translate={this.props.translate}
                        metadata={metadata}
                    />

                    <ModalViewResource
                        title={"Client Information"}
                        subTitle={""}
                        className="max-w-lg"
                        visible={this.state.viewModalOpen}
                        onClose={this.handleToggleViewModal}
                        fields={this.getReadOnlyFields(this.state.selectedItem)}
                        translate={this.props.translate}
                        metadata={metadata}
                    />


                    <ModalConfirm
                        title={"Confirm delete"}
                        text={"Are you sure you want to delete?"}
                        onClose={this.handleToggleConfirmModal}
                        onConfirm={() => {
                            this.props.dispatch(deleteResource({
                                user: LocalStorage.get("user"),
                                query: Object.assign({
                                    [this.getPrimaryKey()]: this.state.selectedItem[this.getPrimaryKey()]
                                }, this.getQuery()),
                                resource: Resources.Client,
                                piggyResource: this.getResourceName()
                            }));
                            this.handleToggleConfirmModal(false)
                        }}
                        visible={this.state.confirmModalOpen}
                    />
                </main>
            </LayoutDashboard>
        )
    }
}

export default connect(state => state)(ClientsPage);
